
    import common from "@/util/common";
    import {useStore} from "@/store";
    import {useRouter, useRoute} from "vue-router";
    import {defineComponent, toRefs, reactive} from "vue";
    import radar from './radar.vue'
    import gauge from './gauge.vue'
    interface State {
        baseInfo:  object[];
        photoList: object[];
        showTip: boolean;
        batterysoh: object;
        templateCode: string;
        isShowRadar: boolean;
    }

    export default defineComponent({
        name: "carInfoH5",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            checkStandardRouter: {
                type: String,
            }
        },
        components: {
            radar,
            gauge
        },
        setup(props: any) {
            let state: State = reactive({
                baseInfo: [],
                photoList: [],
                showTip: false,
                templateCode: '',
                batterysoh:{
                    text: '',
                    class: ''
                },
                isShowRadar: false,

            })
            let store = useStore()
            const router = useRouter();
            const {query} = useRoute();
            const {renderData} = toRefs(props);
            const { templateCode} = query;
            state.templateCode = String(templateCode);
            function getData(list, code, key='value', type='') {
                return common.getDataByCode(list || renderData.value, code, key, type)
            }
            function transScore(score) {
                if (score === '-') {
                    return '-';
                } else if (score === '0') {
                    return 'Хорошо';
                } else if (score === '1' || score === '2') {
                    return 'Предупреждение';
                } else if (score === '3') {
                    return 'Тревога';
                }
            }
            function setCircleGradient() {
                let data = getData(null, 'soh');
                if (data >= 90) {
                    return {
                        text: 'Отличный',
                        class: 'goodRu',
                        dataColor: ["#25F2C4","#02BE8C"],
                        dataShadowColor:'#06C39280'
                    };
                } else if (data < 90 && data >= 80) {
                    return {
                        text: 'Хороший',
                        class: 'betterRu',
                        dataColor: ["#ADFDE2","#60E7DB", "#43E0FF"],
                        dataShadowColor:'#4CE1F480'
                    };
                } else if (data < 80 && data >= 65) {
                    return {
                        text: 'Средний',
                        class: 'middleRu',
                        dataColor: ["#D3E941","#FF9735"],
                        dataShadowColor:'#F4AA3880'
                    };
                } else {
                    return {
                        text: 'Обычный',
                        class: 'normalRu',
                        dataColor: ["#F95051","#FA7E52"],
                        dataShadowColor:'#F9685280'
                    };
                }
            }
            state.batterysoh = setCircleGradient();
            console.log('state.batterysoh:', JSON.stringify(state.batterysoh));
            state.baseInfo = renderData.value;
            
            let cellUnder = getData(props.renderData, 'cellUnderVoltage', 'items'); // 单体欠压
            let cellOver = getData(props.renderData, 'cellOverVoltage', 'items'); // 单体过压
            let difference = getData(props.renderData, 'voltageDifference', 'items');  // 电压差异
            let overTemperature = getData(props.renderData, 'batteryOverTemperature', 'items');    // 电池过温
            let temperatureDifference = getData(props.renderData, 'temperatureDifference', 'items');   // 温度差异
            // state.photoList = getData('photoList', 'items');
            window.addEventListener('click', () => {
                state.showTip = false;
            });
            if (getData(temperatureDifference, 'temperatureDifference') === '-' ||
                getData(overTemperature, 'batteryOverTemperature') === '-' ||
                getData(cellOver, 'cellOverVoltage') === '-' ||
                getData(cellUnder, 'cellUnderVoltage') === '-' ||
                getData(difference, 'voltageDifference') === '-') {
                    state.isShowRadar = false;
            } else {
                state.isShowRadar = true;
            }
            return {
                state,
                router,
                store,
                getData,
                transScore,
                cellUnder,
                cellOver,
                difference,
                overTemperature,
                temperatureDifference

            }
        },
        methods: {
            
            goCarInfo () {
                this.store.dispatch('savePageScrollTop', window.scrollY);
                
                if (this.checkStandardRouter) {
                    let router = 'batteryFrame' + this.checkStandardRouter.charAt(0).toUpperCase() + this.checkStandardRouter.slice(1);
                    this.router.push({
                        path: `/${router}`,
                        query: {
                            checkTitle: '【加购】三电检测',
                            templateCode: this.state.templateCode
                        }
                    })
                } else {
                    this.router.push({
                        path: '/batteryFrameCheckStandard',
                        query: {
                            checkTitle: '【加购】三电检测',
                            templateCode: this.state.templateCode
                        }
                    })
                }
            },

            goToImgView(photo) {
                this.store.dispatch('savePageScrollTop', window.scrollY);
                if (photo === 'all') {
                    this.router.push({
                        path:'/promiseFramePhotoListRu',
                        query: {
                            photoIndex:0,
                            group: 'base',
                            isAll: 'total',
                        }
                    })
                } else {
                    let currentIndex=0;
                    for (let i =0;i<this.state.photoList.length;i++){
                        let item: any = this.state.photoList[i];
                        if (item.code === photo.code) {
                            currentIndex = i;
                            break;
                        }
                    }
                    this.router.push({
                        path:'/promiseFramePhotoListRu',
                        query: {
                            photoIndex: currentIndex,
                            group: 'base' ,
                        }
                    })
                }
            }
        }
    })
